<template>
  <div class="form_con">
    <top-header :type="6" hasBorder="true" :placeholder="'上传签字页'" :bgColor="'#fff'" fontSize="0.32rem" />
    <h3>上传签字页</h3>
    <van-form @submit="onSubmit" validate-trigger="onSubmit">
      <div class="pic_con">
        <van-uploader :before-read="beforeRead" :after-read="afterRead" >
          <img :src="img1" alt="" class="small">
        </van-uploader>
      </div>
      <div class="btn_con">
        <van-button block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
let timmer = null;
import qs from 'qs';
import topHeader from '@/components/header';
export default {
  data() {
    return {
      show: false,
      img1: require('@/assets/img/up.png'),
      image1: '',
    };
  },
  components: {
    topHeader
  },
  mounted() {
    this.$http.post('cms/contractData/reg/getOnlineUploadRecordFiles.do', qs.stringify({
      contractId: this.$route.query.id
    })).then(res => {
      if(res.success && res.obj.signatureFile) {
        this.img1 = 'data:image/jpg;base64,' + res.obj.signatureFile;
        this.image1 = 'data:image/jpg;base64,' + res.obj.signatureFile;
      }
    })
  },
  methods: {
    beforeRead(file) {
      if (file.type.toLowerCase() !== 'image/jpg' && file.type.toLowerCase() !== 'image/png' && file.type.toLowerCase() !== 'image/jpeg' && file.type.toLowerCase() !== 'image/gif') {
        this.$toast('该格式不支持');
        return false;
      } else if (file.size > 5000 * 1024) {
        this.$toast('文件大小不得超过5M');
        return false;
      }
      return true;
    },
    afterRead(file) {
      this.image1 = file.file
      const formData = new FormData();
      formData.append('file', this.image1);
      formData.append('contractId', this.$route.query.id);
      formData.append('fileType', 0);
      this.$http({
        url: 'cms/contractUpoadFile/reg/onlineContractUploadHtqz.do',
        method: 'POST',
        headers: { //添加请求头
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      }).then(res => {
        if(res.success) {
          this.img1 = file.content;
        } else {
          this.$toast(res.msg)
        }
      })
    },
    onSubmit(values) {
      if(!this.image1) {
        this.$toast('请上传签字页');
        return
      } else {
        this.$http({
          url: 'cms/recordUpAudit/reg/addRecordUpAuditOnline.do',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data:{
            contractId: this.$route.query.id
          }
        }).then(res => {
          this.$dialog.alert({
              title: '提示',
              message: '提交成，请耐心等待审核',
          }).then(() => {
            this.$router.go(-1);
          })
        })
      }
    },
    onConfirm(value) {
      this.role = value.text;
      this.showPicker = false;
    },
  },
};
</script>
<style lang="less" scoped>
h3{
  font-size: 0.36rem;
  font-weight: 800;
  padding: 0 16px;
  margin: 0 auto 0.6rem;
}
.form_con{
  padding: 0.3rem 0rem;
  /deep/
  .b_f{
    line-height: 32px;
  }
}
h5{
  font-size: 14px;
  padding: 10px 16px 0;
  color: #646566;
}
.pic_con{
  padding: 16px 16px;
  position: relative;
  .small{
    width: 2.56rem;
    height: 2.56rem;
  }
  .big{
    width: 2.18rem;
    height: 3.4rem;
  }
  p{
    color: #474747;
    font-size: 12px;
    width: 2.56rem;
    text-align: center;
    margin-top: 0.1rem;
    color: #666;
  }
  &:after{
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
  }
}
.col_blue{
  color: #2F72F5;
  font-size: 0.26rem;
}
.btn_con{
  position: fixed;
  bottom: 0.4rem;
  left: 0;
  right: 0;
  padding: 0 0.3rem;
}
.wrap{
  background-color: #fff;
  width: 5.8rem;
  height: 7.84rem;
  border-radius: 0.02rem;
  img{
    width: 4.04rem;
    height: 6.28rem;
  }
}
</style>